/// <reference types="@types/googlemaps" />
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { TuilderUtilities } from '../tuilder-utilities.service';
import { DbService } from '../db.service';
import { DatePipe } from '@angular/common';
import { ViewContactsComponent } from '../view-contacts/view-contacts.component';
import * as MarkerClusterer from '@google/markerclustererplus';
import { } from 'googlemaps';
import { RelativeTimePipe } from '../relative-time.pipe';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, OnDestroy {

  constructor(
    protected utils: TuilderUtilities,
    protected db: DbService,
    public dialog: MatDialog,
    protected router: Router,
    protected datePipe: DatePipe,
    protected timePipe: RelativeTimePipe
  ) {

  }


  EventMap = false;

  markersTpl = {
    colors: {
      red: ['#ff4646', '#590000'],
      blue: ['#0075F4', '#ffffff'],
      orange: ['#F9A825', '#7D5412'],
      oliveYellow: ['#817717', '#ffffff'],
      aqua: ['#006064', '#ffffff'],
      darkBlue: ['#01579B', '#ffffff'],
      yellow: ['#FFEA00', '#6E6500'],
      gold: ['#FFBF00', '#6E6500'],
      purple: ['#9C27B0', '#481252'],
      oliveGreen: ['#558B2F', '#ffffff'],
      green: ['#30ac22', '#99ff99'],
      brightGreen: ['#00FF00', '#005C00'],
      darkPink: ['#880E4F', '#ffffff'],
      theme: ['#03A9F4', '#ffffff'],
      overdue: ['#fe2727', '#ffffff'],
      pink: ['#C2185B', '#ffffff'],
      brightPink: ['#f000ff', '#ffffff'],
      blueGreen: ['#0F9D58', '#ffffff'],
      lightAqua: ['#0097A7', '#ffffff'],
      grey: ['#A3A3A3', '#5B5B5B']
    },
    svg: {
      // tslint:disable-next-line:max-line-length
      normal: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 27.91"><defs><style>.cls-1{fill:COLOR0;}.cls-2{fill:COLOR1;}</style></defs><title>Marker</title><g id="layer1"><g id="g3477"><path id="path4337-3" class="cls-1" d="M2.39,3A7.2,7.2,0,0,0,.48,7.84c.06,3.64,1.7,5,4.33,10A48.49,48.49,0,0,1,7.68,26.3,5.49,5.49,0,0,0,8,27.44c.06,0,.19-.48.32-1.05A48.49,48.49,0,0,1,11.19,18c2.63-5,4.27-6.4,4.33-10a7.25,7.25,0,0,0-1.91-4.88A8.1,8.1,0,0,0,8,.48,7.66,7.66,0,0,0,2.39,3Z"/><circle id="path3049" class="cls-2" cx="8" cy="7.97" r="2.88"/></g></g></svg>',
      // tslint:disable-next-line:max-line-length
      contact: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 27.91"><defs><style>.cls-1{fill:COLOR0;}.cls-2{fill:COLOR1;}</style></defs><title>marker-contact</title><g id="layer1"><g id="g3477"><path id="path4337-3" class="cls-1" d="M2.39,3A7.2,7.2,0,0,0,.48,7.84c.06,3.64,1.7,5,4.33,10A48.49,48.49,0,0,1,7.68,26.3,5.49,5.49,0,0,0,8,27.44c.06,0,.19-.48.32-1.05A48.49,48.49,0,0,1,11.19,18c2.63-5,4.27-6.4,4.33-10a7.25,7.25,0,0,0-1.91-4.88A8.1,8.1,0,0,0,8,.48,7.66,7.66,0,0,0,2.39,3Z"/></g></g><path class="cls-2" d="M8,3.6a2,2,0,1,1-2,2,2,2,0,0,1,2-2M8,8.68c2.25,0,4.06.91,4.06,2v1H3.94v-1C3.94,9.59,5.75,8.68,8,8.68Z"/></svg>',
      // tslint:disable-next-line:max-line-length
      nothome: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.04 26.96"><defs><style>.cls-1{fill:COLOR0;}.cls-2{fill:COLOR1;}</style></defs><title>nothome</title><g id="layer1"><g id="g3477"><path id="path4337-3" class="cls-1" d="M1.91,2.52A7.18,7.18,0,0,0,0,7.36c.06,3.64,1.7,5,4.33,10A48.73,48.73,0,0,1,7.2,25.82,5.69,5.69,0,0,0,7.52,27a3.47,3.47,0,0,0,.32-1.05,48.57,48.57,0,0,1,2.87-8.39c2.63-5,4.27-6.4,4.33-10a7.28,7.28,0,0,0-1.91-4.88A8.09,8.09,0,0,0,7.52,0,7.66,7.66,0,0,0,1.91,2.52Z"/></g></g><path class="cls-2" d="M7.52,2.43a5.39,5.39,0,1,0,5.39,5.39A5.39,5.39,0,0,0,7.52,2.43ZM3,7.8A4.48,4.48,0,0,1,7.52,3.32a4.53,4.53,0,0,1,2.85,1L9,5.75,7.52,4.46,3.76,7.84H4.89v2l-.84.84A4.47,4.47,0,0,1,3,7.8Zm4.49,4.51a4.5,4.5,0,0,1-2.85-1l.44-.44H6.77V9.2l.6-.6h.9v2.25h1.88v-3h1.13L9.62,6.35,11,5a4.49,4.49,0,0,1-3.47,7.34Z"/></svg>',
      // tslint:disable-next-line:max-line-length
      unsure: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.04 26.96"><defs><style>.cls-1{fill:COLOR0;}.cls-2{fill:COLOR1;}</style></defs><title>unsure</title><g id="layer1"><g id="g3477"><path id="path4337-3" class="cls-1" d="M1.91,2.52A7.18,7.18,0,0,0,0,7.36c.06,3.64,1.7,5,4.33,10A48.73,48.73,0,0,1,7.2,25.82,5.69,5.69,0,0,0,7.52,27a3.47,3.47,0,0,0,.32-1.05,48.57,48.57,0,0,1,2.87-8.39c2.63-5,4.27-6.4,4.33-10a7.28,7.28,0,0,0-1.91-4.88A8.09,8.09,0,0,0,7.52,0,7.66,7.66,0,0,0,1.91,2.52Z"/></g></g><path class="cls-2" d="M6.63,11.85l0-.44a3.84,3.84,0,0,1,1-2.91A3.74,3.74,0,0,0,8.81,6.19c0-.86-.53-1.43-1.6-1.45a3,3,0,0,0-1.69.52L5.11,4.2a4.47,4.47,0,0,1,2.41-.67A2.49,2.49,0,0,1,10.33,6,4.54,4.54,0,0,1,8.88,8.93a3.35,3.35,0,0,0-1,2.48l0,.44ZM6.26,14.2a1,1,0,1,1,1,1.05A1,1,0,0,1,6.26,14.2Z"/></svg>',
      // tslint:disable-next-line:max-line-length
      notinterested: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.04 26.96"><defs><style>.cls-1{fill:COLOR0;}.cls-2{fill:COLOR1;}</style></defs><title>notinterested</title><g id="layer1"><g id="g3477"><path id="path4337-3" class="cls-1" d="M1.91,2.52A7.18,7.18,0,0,0,0,7.36c.06,3.64,1.7,5,4.33,10A48.73,48.73,0,0,1,7.2,25.82,5.69,5.69,0,0,0,7.52,27a3.47,3.47,0,0,0,.32-1.05,48.57,48.57,0,0,1,2.87-8.39c2.63-5,4.27-6.4,4.33-10a7.28,7.28,0,0,0-1.91-4.88A8.09,8.09,0,0,0,7.52,0,7.66,7.66,0,0,0,1.91,2.52Z"/></g></g><path class="cls-2" d="M7.52,7.13A1.56,1.56,0,1,0,6,5.57,1.56,1.56,0,0,0,7.52,7.13Z"/><path class="cls-2" d="M4.36,9.53v.77h6.32V9.53C10.68,8.68,9.27,8,7.52,8S4.36,8.68,4.36,9.53Z"/><path class="cls-2" d="M6.86,7.83c.21,0,.43,0,.66,0s.45,0,.66,0h0l3.47-3.47L11,3.69l-1.7,1.7a1.1,1.1,0,0,1,0,.18,1.79,1.79,0,0,1-3.58,0,.88.88,0,0,1,0-.17L4.05,3.69l-.66.66L6.87,7.82Z"/><polygon class="cls-2" points="3.4 11.29 4.05 11.95 5.51 10.48 4.21 10.48 3.4 11.29"/><polygon class="cls-2" points="10.83 10.48 9.53 10.48 10.99 11.95 11.65 11.29 10.83 10.48"/></svg>',
      // tslint:disable-next-line:max-line-length
      bookarea: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.93 24.89"><defs><style>.cls-1{fill:COLOR0;}</style></defs><title>book-area</title><path class="cls-1" d="M22.51,10.35H21.46a10.47,10.47,0,1,1-20,0h-1a11.47,11.47,0,1,0,22.51,3.07A11.55,11.55,0,0,0,22.51,10.35Z"/><path class="cls-1" d="M11.46,23.06a9.63,9.63,0,0,0,9.64-9.64,9.78,9.78,0,0,0-.5-3.07H19.53a8.63,8.63,0,1,1-16.7,3.07,8.72,8.72,0,0,1,.57-3.07H2.33a9.78,9.78,0,0,0-.5,3.07A9.63,9.63,0,0,0,11.46,23.06Z"/><path class="cls-1" d="M11.46,20.94A7.51,7.51,0,0,0,19,13.42a7.36,7.36,0,0,0-.66-3.07H4.6a7.51,7.51,0,0,0,6.86,10.59Z"/><polygon class="cls-1" points="14.44 0 12.31 1.91 12.31 6.59 14.44 4.67 14.44 0"/><path class="cls-1" d="M7,8.36s.07,0,.11,0a5.1,5.1,0,0,1,2-.47,3.9,3.9,0,0,1,2.33.64,5.18,5.18,0,0,1,2.34-.64,4.31,4.31,0,0,1,2,.45.2.2,0,0,0,.11,0,.24.24,0,0,0,.21-.22V1.91a2.81,2.81,0,0,0-.85-.42V7.23A4.93,4.93,0,0,0,13.8,7a5.18,5.18,0,0,0-2.34.64V1.91a4,4,0,0,0-2.33-.63,4,4,0,0,0-2.34.63V8.14A.24.24,0,0,0,7,8.36Z"/></svg>',
      // tslint:disable-next-line:max-line-length
      contactsarea: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.93 24.64"><defs><style>.cls-1{fill:COLOR0;}</style></defs><title>contacts-area</title><circle class="cls-1" cx="11.46" cy="2" r="2"/><path class="cls-1" d="M15.52,7.08c0-1.09-1.81-2-4.06-2S7.4,6,7.4,7.08v1h8.12Z"/><path class="cls-1" d="M22.51,10.1H21.46a10.47,10.47,0,1,1-20,0h-1a11.47,11.47,0,1,0,22.51,3.07A11.55,11.55,0,0,0,22.51,10.1Z"/><path class="cls-1" d="M11.46,22.81a9.63,9.63,0,0,0,9.64-9.64,9.78,9.78,0,0,0-.5-3.07H19.53a8.63,8.63,0,1,1-16.7,3.07A8.72,8.72,0,0,1,3.4,10.1H2.33a9.78,9.78,0,0,0-.5,3.07A9.63,9.63,0,0,0,11.46,22.81Z"/><path class="cls-1" d="M11.46,20.69A7.51,7.51,0,0,0,19,13.17a7.36,7.36,0,0,0-.66-3.07H4.6a7.51,7.51,0,0,0,6.86,10.59Z"/></svg>',
      // tslint:disable-next-line:max-line-length
      bookpin: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 15.04 26.96"><defs><pattern id="image" patternUnits="userSpaceOnUse" width="{PATTERNWIDTH}" height="{PATTERNHEIGHT}" x="0" y="0"><image xlink:href="{SRC}" x="{X}" y="{Y}" width="{IMAGEWIDTH}" height="{IMAGEHEIGHT}" preserveAspectRatio="xMinYMin slice"/></pattern></defs><title>BookPin</title><g><path id="path4337-3" d="M1.91,2.52A7.18,7.18,0,0,0,0,7.36c.06,3.64,1.7,5,4.33,10A48.73,48.73,0,0,1,7.2,25.82,5.69,5.69,0,0,0,7.52,27a3.47,3.47,0,0,0,.32-1.05,48.57,48.57,0,0,1,2.87-8.39c2.63-5,4.27-6.4,4.33-10a7.28,7.28,0,0,0-1.91-4.88A8.09,8.09,0,0,0,7.52,0,7.66,7.66,0,0,0,1.91,2.52Z" fill="url(#image)"/></g></svg>',
      // tslint:disable-next-line:max-line-length
      personpin: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 19.02 32.79"><defs><style>.cls-3{fill:COLOR0;}</style><pattern id="image" patternUnits="userSpaceOnUse" width="{PATTERNWIDTH}" height="{PATTERNHEIGHT}" x="0" y="0"><image xlink:href="{SRC}" x="{X}" y="{Y}" width="{IMAGEWIDTH}" height="{IMAGEHEIGHT}" preserveAspectRatio="xMinYMin slice"/></pattern></defs><title>person-pin</title><g class="cls-2"><path id="path4337-3" class="cls-1" d="M3.9,4.52A7.18,7.18,0,0,0,2,9.36c.06,3.64,1.7,5,4.33,10a49.59,49.59,0,0,1,2.87,8.46A5.09,5.09,0,0,0,9.51,29a3.47,3.47,0,0,0,.32-1.05,48.57,48.57,0,0,1,2.87-8.39c2.63-5,4.27-6.4,4.33-10a7.28,7.28,0,0,0-1.91-4.88A8.11,8.11,0,0,0,9.51,2,7.64,7.64,0,0,0,3.9,4.52Z" fill="url(#image)"/></g><path class="cls-3" d="M4.87,3.62l0,0H5.2l0,0h0a4.8,4.8,0,0,1,.48-.3l-1-1.73a9.09,9.09,0,0,0-1,.71L4.87,3.62Z"/><path class="cls-3" d="M2.57,6.57h0v0h.19a1.51,1.51,0,0,1,.15-.28l-1.75-1A9.34,9.34,0,0,0,.62,6l1.87.73A1.67,1.67,0,0,1,2.57,6.57Z"/><path class="cls-3" d="M3.64,4.81h0c.08-.09.16-.19.25-.28l.22-.24L2.7,2.88l-.29.3a6.93,6.93,0,0,0-.53.64L3.47,5Z"/><path class="cls-3" d="M2,8.71H2v0H2v0a8.52,8.52,0,0,1,.16-.88L.24,7.26A8.72,8.72,0,0,0,0,8.52l2,.19Z"/><path class="cls-3" d="M4.43,16h0l-.09-.17-.08-.13h0l0,0h0L4,15.29l-1.72,1,.32.56.19.31,1.72-1Z"/><path class="cls-3" d="M2.58,12.53h0c0-.13-.09-.26-.13-.38H2.35v0h0v0h0l0,0v0h0v0h0l-1.93.53a10.54,10.54,0,0,0,.39,1.16l1.86-.74Z"/><path class="cls-3" d="M3.41,14.25h0c-.13-.23-.25-.46-.36-.68l-1.79.89c.16.32.33.64.52,1l1.74-1Z"/><path class="cls-3" d="M16.65,7.23h0v0l1.91-.59a9.45,9.45,0,0,0-.46-1.19l-1.81.85A7.28,7.28,0,0,1,16.65,7.23Z"/><path class="cls-3" d="M15.25,4.79h0v0h.09a5.32,5.32,0,0,1,.36.47h0v0h0l0,.08,1.68-1.1a9.29,9.29,0,0,0-.77-1L15.25,4.79Z"/><path class="cls-3" d="M14.51,4h0l1.34-1.49a10.47,10.47,0,0,0-1-.78L13.77,3.45A8.32,8.32,0,0,1,14.51,4Z"/><path class="cls-3" d="M5.39,17.66h0l-.13-.23h0L5,17,3.28,18l.49.85,1.74-1Z"/><path class="cls-3" d="M17,8.61h0v0h0v0h0a4.08,4.08,0,0,1,0,.61l2,0A8.81,8.81,0,0,0,18.9,8l-2,.32C16.94,8.44,17,8.53,17,8.61Z"/><path class="cls-3" d="M12.19,2.59h.17l.5.24h.05l.94-1.77C13.48,1,13.1.8,12.72.65L12,2.52l.19.07Z"/><path class="cls-3" d="M8.51,2.07h0c.18,0,.37,0,.55-.06h.42l0-2A10.67,10.67,0,0,0,8.23.09l.28,2Z"/><path class="cls-3" d="M11.53.28A10.58,10.58,0,0,0,10.3.06l-.23,2a6.48,6.48,0,0,1,1,.17Z"/><path class="cls-3" d="M6.76,2.54h.09l.43-.15h.11l.14,0L7,.35A8,8,0,0,0,5.81.77l.78,1.84Z"/><path class="cls-3" d="M2,9.71,0,9.8A11.34,11.34,0,0,0,.12,11l2-.3A9.83,9.83,0,0,1,2,9.71Z"/><path class="cls-3" d="M11,23.92h0L11,24l1.9.63.31-.91-1.88-.67Z"/><path class="cls-3" d="M12.78,19.37a1.09,1.09,0,0,0-.08.15h0v0h0l-.26.59,1.84.78c.1-.21.19-.43.29-.64l.06-.12-1.77-.93Z"/><path class="cls-3" d="M11.86,21.49h0v0h0l-.09.24h0v0h0v0h0l0,.13,1.86.71.35-.89L12,21.18C12,21.28,11.91,21.39,11.86,21.49Z"/><path class="cls-3" d="M14.7,16l0,0-.43.72,1.73,1L16.4,17l.08-.15-1.72-1Z"/><path class="cls-3" d="M13.35,18.3h0l-.05.09,1.76,1,.47-.84-1.74-1Z"/><path class="cls-3" d="M17,10.53h0v0h0c0,.22-.07.44-.11.65h0l2,.42A12.16,12.16,0,0,0,19,10.55l-2-.19A1,1,0,0,1,17,10.53Z"/><path class="cls-3" d="M15.27,15,17,16c.18-.32.36-.63.52-.93l-1.77-.94Z"/><path class="cls-3" d="M16.57,12.31h0l-.13.36h-.05a3.79,3.79,0,0,1-.18.42h0l1.82.82A11.11,11.11,0,0,0,18.46,13l-1.89-.64Z"/><path class="cls-3" d="M7.17,21.39h0l-.27-.67h0v0L5,21.33c.12.3.24.59.35.89l1.87-.73Z"/><path class="cls-3" d="M10.69,24.82h0l0,.06h0v0h0v0h0l-.18.59,1.93.55c.08-.3.18-.61.27-.92l-1.91-.59C10.72,24.73,10.7,24.77,10.69,24.82Z"/><path class="cls-3" d="M8.51,25.28h0v0h0l-.11-.35h0v0h0c0-.15-.09-.31-.14-.46l-1.9.61c.09.31.19.61.28.92l1.92-.57Z"/><path class="cls-3" d="M6.42,19.59h0v0h0v0h0v0h0l0-.07h0c-.1-.18-.19-.36-.29-.53H6l0-.05-1.76,1,.29.52.09.22,1.83-.8Z"/><path class="cls-3" d="M7.73,22.9h0v0h0v0h0l0-.1h0v0h0l0-.08h0v0h0l-1.88.69c.11.3.22.6.32.9l1.9-.65C7.84,23.22,7.79,23.06,7.73,22.9Z"/><path class="cls-3" d="M9,26.85h0v0h0v0h0v0h0v0h0v0h0l-1.93.53c.09.31.17.62.25.93L9,27.21Z"/><path class="cls-3" d="M10.15,26.62h0v0h0v0h0l0,.08h0c0,.15-.07.29-.11.43l1.94.48.24-.93-1.93-.51Z"/><path class="cls-3" d="M9.77,28.24h0v0h0v0h0v0h0l0,.08h0v0h0c0,.14-.07.29-.11.43l1.94.47.24-.92L9.83,28Z"/><path class="cls-3" d="M9.49,29h0v0h0l-.12-.33h0v0h0v0h0v0h0v0h0v0h0c0-.07,0-.13-.05-.2l-1.95.46a8.39,8.39,0,0,0,.27.85L9.49,29Z"/><polygon class="cls-3" points="9.5 32.79 11.26 30.02 7.75 30.02 9.5 32.79"/></svg>',
      // tslint:disable-next-line:max-line-length
      genericbook: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.04 26.96"><defs><style>.cls-1{fill:COLOR0;}.cls-2{fill:COLOR1;}</style></defs><title>genericbook</title><g id="layer1"><g id="g3477"><path id="path4337-3" class="cls-1" d="M1.91,2.52A7.18,7.18,0,0,0,0,7.36c.06,3.64,1.7,5,4.33,10A48.73,48.73,0,0,1,7.2,25.82,5.69,5.69,0,0,0,7.52,27a3.47,3.47,0,0,0,.32-1.05,48.57,48.57,0,0,1,2.87-8.39c2.63-5,4.27-6.4,4.33-10a7.28,7.28,0,0,0-1.91-4.88A8.09,8.09,0,0,0,7.52,0,7.66,7.66,0,0,0,1.91,2.52Z"/></g></g><polygon class="cls-2" points="10.29 3.11 8.31 4.89 8.31 9.24 10.29 7.46 10.29 3.11"/><path class="cls-2" d="M3.37,10.38s.06,0,.1,0a4.73,4.73,0,0,1,1.87-.43,3.7,3.7,0,0,1,2.18.59A4.7,4.7,0,0,1,9.7,9.92a4,4,0,0,1,1.87.42s.06,0,.1,0a.22.22,0,0,0,.2-.2V4.38a2.67,2.67,0,0,0-.79-.4V9.32A4.84,4.84,0,0,0,9.7,9.13a4.7,4.7,0,0,0-2.18.59V4.38a3.63,3.63,0,0,0-2.18-.59,3.62,3.62,0,0,0-2.17.59v5.8A.22.22,0,0,0,3.37,10.38Z"/></svg>'
    }
  };

  programID: Number;
  programs: Array<Object> = [];
  isMenuOpen = false;
  permissions = 'Full';
  subs = [];
  unsortedContacts = [];
  bookPinMarkers = [[], []];
  contactPinMarkers = [];
  contactPoints = [];
  map;
  boolean = Boolean;
  markerCluster;
  contactsMarkerCluster;
  wsConnection;
  infoWindow;
  refreshDisabled = 0;
  initialised = 0;
  mapSaveTimeout;
  leLocations: Object = {};
  leLocationsArray: Array<Object> = [];
  currentPaths: Object = {};
  myLocationPaths: Object = {};
  ResolveOnMapInit = null;
  MapInitComplete = false;
  currentEditingPath: String = '';
  ContactsMarkerClusterZoomLevel = 15;
  currentEditingPathBackup;
  layers = [];
  filters = localStorage.filters && JSON.parse(localStorage.filters) || {
    contacts: '',
    followup: ''
  };
  adrSearch = '';
  searchResponse = [];
  searchResponseError = false;
  surveyQuestions: Object = {};
  lastHighlightedContact = null;
  editingContact = null;
  bookItems = null;
  svgMapPins = {};
  svgBookPins = {};

  paths = {
    walking: [],
    visits: []
  };

  colors = [
    null,
    '#F70000',
    '#0075F4',
    '#21BF37',
    '#F200D6',
    '#EFE300',
    '#ff8000',
    '#00E5AE'
  ];

  logout() {
    this.db.q('magabooksApp:mbLogout').then(() => {
      this.router.navigateByUrl('login');
    });
  }

  getSvgMarker(kind?, color?) {

    kind = kind || 'normal';
    color = color || 'red';

    let svg = this.markersTpl.svg[kind];
    const colors = this.markersTpl.colors[color];

    for (const [index, color] of colors.entries()) {
      svg = svg.replace('COLOR' + index, color);
    }

    return svg;

  }

  getSvgDataUrl(kind?, color?) {

    const key = kind + (color ? '_' + color : '');

    let output = null;

    if (!this.svgMapPins[key] || this.svgMapPins[key] === 1) {

      if (!this.svgMapPins[key]) {

        const svg = this.getSvgMarker(kind, color);

        output = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg);

        this.db.q('magabooksApp:saveImageSvg', { svg: svg, key: key }).then((res) => {

          this.svgMapPins[key] = res['url'];

        });

      }

      this.svgMapPins[key] = 1;

    } else {

      output = this.svgMapPins[key];

    }

    return output;

  }

  ngOnDestroy() {
    if (this.wsConnection) {
      this.wsConnection.close();
    }
  }

  highlightContact(contact, color, type?) {

    type = type || this.getContactType(contact.contacts);

    contact.marker.setIcon({

      url: this.getSvgDataUrl(type, color),
      scaledSize: new google.maps.Size(33.5, 60)

    });

  }

  applyAdrToContact(response) {

    const placeID = response.place_id;
    const lat = response.geometry.location.lat;
    const lng = response.geometry.location.lng;
    const address = response.formatted_address;

    const point = this.editingContact.point;

    const books = this.bookPinMarkers[1].find((row) => {

      const distance = this.getDistanceBetweenPoints(
        { lat: row[0].latitude, long: row[0].longitude }, { lat: point.lat, long: point.long }
      );

      return distance < 1;

    });

    let bookMarker;

    if (books) {
      bookMarker = this.bookPinMarkers[0][this.bookPinMarkers[1].indexOf(books)];
    } else {
      bookMarker = null;
    }

    point.GooglePlaceID = placeID;
    point.lat = lat;
    point.long = lng;
    point.address = address;

    this.db.q('magabooksApp:saveLocationData', { loc: [point] });

    if (books) {

      this.db.q('magabooksApp:addBookToContact', { books: books, point: point, contact: this.editingContact.contacts[0] });

    }

    const coords = { lat: lat, lng: lng };

    this.editingContact.marker.setPosition(coords);

    if (bookMarker) {
      bookMarker.setPosition(coords);
    }

    this.highlightContact(this.editingContact, 'red');

    const index = this.unsortedContacts.indexOf(this.editingContact);
    this.unsortedContacts.splice(index, 1);

    this.lastHighlightedContact = null;
    this.editingContact = null;

  }

  deleteEditingContact() {

    this.editingContact.marker.setMap(null);

    const index = this.unsortedContacts.indexOf(this.editingContact);

    this.unsortedContacts.splice(index, 1);

    this.db.q('magabooksApp:deleteContactAndPoint', { point: this.editingContact.point, contacts: this.editingContact.contacts });

    this.lastHighlightedContact = null;
    this.editingContact = null;

  }

  cancelEditingContact() {

    this.editingContact = null;
    const color = this.lastHighlightedContact.point.GooglePlaceID ? 'red' : 'brightPink';
    this.highlightContact(this.lastHighlightedContact, color);
    this.lastHighlightedContact = null;

  }

  openUnsortedContact(contactObj) {

    const point = contactObj.point;

    this.CentreMap({ lat: point.lat, lng: point.long }, 19.5); // 19.5 = zoom level

    if (this.lastHighlightedContact) {
      const color = this.lastHighlightedContact.point.GooglePlaceID ? 'red' : 'brightPink';
      this.highlightContact(this.lastHighlightedContact, color);
    }

    this.lastHighlightedContact = contactObj;

    this.highlightContact(contactObj, 'brightGreen');

    let txt = '';

    if (typeof contactObj.point.address === 'object') {
      for (const value of Object.values(contactObj.point.address)) {
        txt += ' ' + value;
      }
    } else {
      txt = contactObj.point.address;
    }

    contactObj.adrSearch = txt;

    this.searchMap(txt);

    this.editingContact = contactObj;

  }

  CentreMap(coords, zoom?) {
    if (!zoom) {
      zoom = 19;
    }
    this.map.setCenter(coords);
    this.map.setZoom(zoom);
  }

  initSearchPanel() {
    this.searchResponse = null;
    this.searchResponseError = false;
  }

  newContact(address) {

    const coords = address && address.geometry && address.geometry.location;

    const dialogData = {
      address: address,
      questions: this.surveyQuestions,
      id: null,
      title: 'Loading...'
    };

    const dialogRef = this.dialog.open(ViewContactsComponent, {
      width: '900px',
      disableClose: true,
      position: {
        top: '3vh'
      },
      data: dialogData
    });

    dialogData.id = dialogRef.id;

    dialogRef.afterClosed().subscribe(result => {

      this.adrSearch = null;

    });

  }

  searchMap(keywords?) {

    keywords = keywords || this.adrSearch;

    const bounds = this.map.getBounds();
    const southWest = bounds.getSouthWest();
    const northEast = bounds.getNorthEast();

    const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(keywords) +

      // Add search bounding to map viewport area
      '&bounds=' +
      southWest.lat() +
      ',' +
      southWest.lng() + '|' +
      northEast.lat() +
      ',' +
      northEast.lng() +

      '&key=' +
      this.db.mapsApiKey;

    this.db.getJson(
      url
    ).subscribe(data => {

      this.searchResponseError = false;

      const response = data['results'];

      this.searchResponse = response;

      if (response.length === 1) {

      } else if (!response.length) {

        this.searchResponseError = true;

      }

    });

  }

  drawPath(coords, personID, pin, locInfo) {

    if (!pin) {
      return;
    }

    const color = this.colors[pin['color']];
    // const name = pin['name'];

    let path;

    if (!this.currentPaths[personID]) {

      const lineSymbol = {
        path: google.maps.SymbolPath.CIRCLE,
        fillOpacity: 0.75,
        scale: 3
      };

      path = new google.maps.Polyline({
        path: [coords],
        geodesic: true,
        strokeColor: color,
        strokeOpacity: 0,
        icons: [{
          icon: lineSymbol,
          offset: '0',
          repeat: '10px'
        }],
        strokeWeight: 8
      });

      path.setMap(this.map);

      this.currentPaths[personID] = {
        path: path,
        time: locInfo.time,
        lastSpeed: locInfo.spd
      };

    } else {

      path = this.currentPaths[personID].path;

    }

    const polyPath = path.getPath();
    const newPoint = new google.maps.LatLng(coords.lat, coords.lng);

    polyPath.push(newPoint);

  }

  hideMarkersNotInView(markers) {

    const bounds = this.map.getBounds();

    const boundsLiteral = bounds && new google.maps.LatLngBounds(
      bounds.getSouthWest(), bounds.getNorthEast()
    );

    for (const marker of markers) {
      const Visible = (bounds && !boundsLiteral.contains(marker.getPosition())) ? false : true;

      marker.setMap(Visible ? this.map : null);
      marker.setVisible(Visible);

    };

  }

  removeContactsMarkerCluster() {

    if (this.contactsMarkerCluster) {
      this.contactsMarkerCluster.setMap(null);
      this.contactsMarkerCluster = null;
    }

  }

  addContactsMarkerCluster() {

    if (!this.contactsMarkerCluster) {

      this.contactsMarkerCluster = new MarkerClusterer(this.map, this.contactPinMarkers, {
        maxZoom: this.ContactsMarkerClusterZoomLevel,
        ignoreHidden: true,
        styles: [
          {
            textColor: '#000',
            anchorText: [3, 0],
            url: this.getSvgDataUrl('contactsarea', 'blue'),
            height: 50,
            width: 40
          },
          {
            textColor: '#000',
            anchorText: [3, 0],
            url: this.getSvgDataUrl('contactsarea', 'gold'),
            height: 50,
            width: 40
          },
          {
            textColor: '#000',
            anchorText: [3, 0],
            url: this.getSvgDataUrl('contactsarea', 'red'),
            height: 50,
            width: 40
          }
        ],
        minimumClusterSize: 1
      });

    }

  }

  changeFilter(filter) {

    localStorage.filters = JSON.stringify(this.filters);

    const bounds = this.map.getBounds();

    const boundsLiteral = bounds && new google.maps.LatLngBounds(
      bounds.getSouthWest(), bounds.getNorthEast()
    );

    if ({
      contacts: 1,
      followup: 1
    }[filter]) { // contacts or followup

      const ShowContacts = this.layers[4];
      const MapZoomLevel = this.map.getZoom();
      let NumVisiblePins = 0;

      for (const [index, row] of Object.entries(this.contactPoints)) {
        
        const contacts = row.contacts;
        const marker = this.contactPinMarkers[index];
        let Visible = false;

        if (this.filters.contacts === 'home') {
          this.filters.contacts = 'contact';
          localStorage.filters = JSON.stringify(this.filters);
        }

        if (
          (
            // If marker is within the map viewport
            bounds && boundsLiteral.contains(marker.getPosition())

            // Ignore if marker cluster ON (at zoom level breakpoint)
            // (this.contactsMarkerCluster && this.map.getZoom() <= this.ContactsMarkerClusterZoomLevel)

          ) &&
          ShowContacts
        ) {

          const type = this.getContactType(contacts);
          const followupDue = this.hasAnyFollowupDue(contacts);

          if (
            (!this.filters.contacts ||
              (type === this.filters.contacts) ||
              (this.filters.contacts === 'nothome' && type === 'notinterested')
            ) &&
            (!this.filters.followup || (this.filters.followup && followupDue))
          ) {
            Visible = true;
            NumVisiblePins++;
          }

        }

        marker.setMap(Visible ? this.map : null);
        marker.setVisible(Visible);

      };

      if (NumVisiblePins < 300) {
        this.removeContactsMarkerCluster();
      } else {
        this.addContactsMarkerCluster();
      }

      if (this.contactsMarkerCluster) {

        this.contactsMarkerCluster.repaint();

      }

    }

  }

  changeLayer(index) {

    this.db.mapLayers = this.layers;

    const layersCopy = JSON.parse(JSON.stringify(this.layers));

    for (const [key, val] of Object.entries(this.layers)) {
      layersCopy[key] = val ? 1 : 0;
    };

    localStorage.layers = JSON.stringify(layersCopy);

    const value = this.layers[index];

    switch (index) {

      case 0: // Book Pins

        if (value) {
          this.markerCluster.addMarkers(this.bookPinMarkers[0]);
        } else {
          this.markerCluster.clearMarkers();
        }

        break; // Location Pins
      case 1:

        for (const le of Object.values(this.leLocations)) {
          le['marker'].setMap(value ? this.map : null);
        };

        break;
      case 2: // Walking

        for (const path of Object.values(this.paths.walking)) {
          path.setMap(value ? this.map : null);
        };

        break;
      case 3: // Visits

        for (const path of Object.values(this.paths.visits)) {
          path.setMap(value ? this.map : null);
        };

        break;
      case 4: // Contacts

        for (const marker of this.contactPinMarkers) {
          marker.setMap(value ? this.map : null);
        }

        break;
    }

    this.changeFilter('contacts');

  }

  updateLeMarker(coords, personID, pin, locInfo) {

    personID = personID || locInfo.kf_personID;

    const lePosObj = this.leLocations[personID];

    if (lePosObj && lePosObj['marker']) {

      lePosObj['marker'].setPosition(coords);
      lePosObj['coords'] = coords;
      lePosObj['time'] = locInfo.time;
      lePosObj['battery'] = locInfo.battery;


    } else {

      this.addLeMarker(coords, personID, pin, locInfo);

    }

    this.leLocationsArray = Object.values(this.leLocations)

  }

  addLeMarker(coords, personID, pin, locInfo) {

    if (!pin) {
      return;
    }

    const contentString = '<div id="content" style="color:#000;">' +
      '<h3 id="firstHeading" class="firstHeading">' + pin['name'] + '</h3>' +
      '</div>';

    const markerOptions = {
      position: coords,
      map: this.map,
      icon: {

        url: pin.url,
        scaledSize: new google.maps.Size(33.5, 60)

      }
    };

    const marker = new google.maps.Marker(markerOptions);

    if (!this.infoWindow) {
      this.infoWindow = new google.maps.InfoWindow({
        content: ''
      });
    }

    marker.addListener('click', () => {
      this.infoWindow.setContent(contentString);
      this.infoWindow.open(this.map, marker);
    });

    this.leLocations[personID] = {
      coords: coords,
      pin: pin,
      marker: marker,
      time: locInfo.time,
      battery: locInfo.battery,
      id: personID
    };

    this.leLocationsArray = Object.values(this.leLocations)

    if (!this.layers[1]) {
      marker.setMap(null);
    }

  }

  deleteCurrentEditingPath() {
    if (confirm('Delete Path?')) {
      const bits = this.currentEditingPath.split('-');
      const personIndex = bits[0];
      const pathIndex = bits[1];
      const PersonData = this.myLocationPaths[personIndex];
      const PolyLinePath = PersonData['trackPaths'][pathIndex];

      this.db.q('magabooksApp:saveLocationData', { trash: PersonData['tracks'][pathIndex] });

      this.clearCurrentEditingPath();

      PolyLinePath.setMap(null);

      PersonData['trackPaths'].splice(pathIndex, 1);
      PersonData['tracks'].splice(pathIndex, 1);

    }
  }

  cancelCurrentEditingPath() {

    const bits = this.currentEditingPath.split('-');
    const personIndex = bits[0];
    const pathIndex = bits[1];
    const PersonData = this.myLocationPaths[personIndex];
    const PolyLinePath = PersonData['trackPaths'][pathIndex];

    PersonData['tracks'][pathIndex] = this.currentEditingPathBackup;

    const coords = this.getCoordsFromRaw(this.currentEditingPathBackup);

    PolyLinePath.setPath(coords);

    this.clearCurrentEditingPath();

  }

  saveCurrentEditingPath() {

    const bits = this.currentEditingPath.split('-');
    const personIndex = bits[0];
    const pathIndex = bits[1];
    const PersonData = this.myLocationPaths[personIndex];
    const RowLatLngData = PersonData['tracks'][pathIndex];
    const trash = PersonData['trash'];

    this.db.q('magabooksApp:saveLocationData', { loc: RowLatLngData, trash: trash });

    if (trash) {
      trash.length = 0;
    }

    this.clearCurrentEditingPath();

  }

  clearCurrentEditingPath() {
    if (this.currentEditingPath) {
      const bits = this.currentEditingPath.split('-');
      const personIndex = bits[0];
      const PersonData = this.myLocationPaths[personIndex];

      for (const marker of PersonData['markers']) {
        marker.setMap(null);
      }

      PersonData['markers'].length = 0;

      this.currentEditingPath = null;
      this.currentEditingPathBackup = undefined;

    }
  }

  getCoordsFromRaw(RowLatLngData) {
    return RowLatLngData.map(row => {
      return { lat: row.lat, lng: row.long };
    })
  }

  setPolylineHandlers() {

    for (const [personIndex, PersonData] of Object.entries(this.myLocationPaths)) {
      
      const id = PersonData['personID'];

      PersonData['markers'] = [];

      for (const path of PersonData['trackPaths']) {

        google.maps.event.addListener(path, 'click', () => {

          const pathIndex = PersonData['trackPaths'].indexOf(path);

          const editKey = personIndex + '-' + pathIndex;

          const RowLatLngData = PersonData['tracks'][pathIndex]; // lattitude and longitude data
          const PolyLinePath = PersonData['trackPaths'][pathIndex];

          if (this.currentEditingPath === editKey) {
            return;
          } else if (this.currentEditingPath) {
            this.saveCurrentEditingPath();
          }

          for (const row of RowLatLngData) {

            const markerObj = {
              position: { lat: parseFloat(row.lat), lng: parseFloat(row.long) },
              draggable: true,
              // animation: google.maps.Animation.DROP,
              map: this.map
            };

            const newMarker = new google.maps.Marker(markerObj);

            PersonData['markers'].push(newMarker);
            // this.bookPinMarkers.push(newMarker);

            const infowindow = new google.maps.InfoWindow({
              content: ' '
            });

            google.maps.event.addListener(newMarker, 'dragend', () => {

              const rowIndex = RowLatLngData.indexOf(row);

              const pos = newMarker.getPosition();
              const RawLatLngPoint = RowLatLngData[rowIndex];

              RawLatLngPoint.lat = pos.lat();
              RawLatLngPoint.long = pos.lng();

              const coords = this.getCoordsFromRaw(RowLatLngData);

              PolyLinePath.setPath(coords);

            });

            const btn = document.createElement('button');
            btn.onclick = () => {

              const rowIndex = RowLatLngData.indexOf(row);

              PersonData['trash'] = PersonData['trash'] || [];
              PersonData['trash'].push(RowLatLngData[rowIndex]);

              PersonData['markers'][rowIndex].setMap(null); // Remove marker
              PersonData['markers'].splice(rowIndex, 1);

              RowLatLngData.splice(rowIndex, 1); // remove path point

              // Set new path
              const coords = this.getCoordsFromRaw(RowLatLngData);
              PolyLinePath.setPath(coords);

            };
            btn.innerText = 'Delete Point';

            google.maps.event.addListener(newMarker, 'click', function () {
              infowindow.setContent(btn);
              infowindow.open(this.map, this);
            });

          };

          this.currentEditingPath = editKey;

          this.currentEditingPathBackup = RowLatLngData.map(r => ({...r}));

        });

      }


    };

  }

  getDistanceBetweenPoints(point1, point2) {

    if ((point1.lat === point2.lat) && (point1.long === point2.long)) {

      return 0;

    } else {
      const radlat1 = Math.PI * point1.lat / 180;
      const radlat2 = Math.PI * point2.lat / 180;
      const theta = point1.long - point2.long;
      const radtheta = Math.PI * theta / 180;
      let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = dist * 1609.34; // conversion to meters;

      return dist;
    }
  }

  getContactType(contacts) {

    return this.utils.getContactType(contacts);

  }

  hasAnyFollowupDue(contacts) {
    let followUps = [];
    for (const row of contacts) {
      if (row.followup) {
        followUps = followUps.concat(row.followup);
      }
    };

    let output = '';

    if (followUps.length) {

      const now = (new Date()).getTime();
      const oneDay = 86400 * 1000;

      for (const row of followUps) {
        const time = parseInt(row['time'], 10);
        const relativeStr = this.timePipe.transform(time);
        if (now > time) {
          output = 'overdue';
        } else if (
          (time - now) < oneDay || relativeStr.match('Tomorrow') &&
          output !== 'overdue'
        ) {
          output = 'close';
        }

      };

    }

    return output || false;

  }

  initMap() {

    const promise = new Promise((resolve, reject) => {

      this.ResolveOnMapInit = resolve;

    });

    if (this.db.mapLayers) {
      this.layers = this.db.mapLayers;
    }

    this.initialised = 1;

    this.refreshDisabled = 1;

    this.utils.loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyDF9ICs220WRHhEpm3vtkPfq6Rp-rEL74g').then(() => {

      const dbData = this.db.getdata();

      if (!dbData) {
        return;
      }

      let dataPromise;

      if (this.EventMap) {

        dataPromise = this.db.loadEvent(window.location.pathname.split('/')[2]);

      } else {

        dataPromise = this.db.q('magabooksApp:getEntries', {
          start: parseInt(dbData['start'], 10) * 1000,
          end: parseInt(dbData['end'], 10) * 1000,
          program: this.db.program.kp_programID
        });

      }

      dataPromise.then((data) => {

        this.svgMapPins = data['svgImages'];
        this.svgBookPins = data['svgBookPins'];

        if (!data['pointsExpanded']) {

          const locationPoints = {};

          // Expande LocationPoints Data Array
          for (const [personID, rows] of Object.entries((data['locationPoints'] || [])[1] || []) as any[]) {

            locationPoints[personID] = [];

            for (const row of rows) {

              const obj = {};

              for (const [idx, header] of data['locationPoints'][0]) {

                obj[header] = row[idx];

              };

              locationPoints[personID].push(obj);

            }

          }

          data['locationPoints'] = locationPoints;

          data['pointsExpanded'] = true;

        }

        this.surveyQuestions = data['surveyQuestions'];

        for (const rows of Object.values(this.myLocationPaths)) {

          for (const path of rows['trackPaths']) {
            path.setMap(null);
          }

          if (rows['trackPaths']) {
            rows['trackPaths'].length = 0;
          }

        }

        this.paths = {
          walking: [],
          visits: []
        };

        // this.currentPaths.length = 0;

        let groupedEntries = {};

        this.bookPinMarkers[0].length = 0;
        this.bookPinMarkers[1].length = 0;

        for (const entry of data['entries']) {
          const key = [
            entry['time'],
            entry['latitude'],
            entry['longitude']
          ].join('-');
          groupedEntries[key] = groupedEntries[key] || [];
          groupedEntries[key].push(entry);
        };

        groupedEntries = Object.values(groupedEntries)

        if (!this.map) {

          let localMapCentre;

          if (localStorage.mapCentre) {

            localMapCentre = JSON.parse(localStorage.mapCentre);

          } else {

            localMapCentre = null;

          }

          const centre = localMapCentre || this.db.mapCentre || data['mapCentre'] || [-33, 151],
            zoom = parseInt(localStorage.mapZoom, 10) || this.db.mapZoom || data['mapZoom'] || 4;

          this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: zoom,
            center: { lat: centre[0], lng: centre[1] }
          });

          // this.ResolveOnMapInit

          google.maps.event.addListener(this.map, 'idle', (ev) => {

            const coords = this.map.getCenter();
            this.db.mapCentre = [coords.lat(), coords.lng()];
            localStorage.mapCentre = JSON.stringify(this.db.mapCentre);
            localStorage.mapZoom = this.db.mapZoom = this.map.getZoom();

            if (this.mapSaveTimeout) {
              window.clearTimeout(this.mapSaveTimeout);
            }

            this.mapSaveTimeout = window.setTimeout(() => {
              this.db.q('magabooksApp:saveMapCoord', {
                center: this.db.mapCentre,
                zoom: this.db.mapZoom
              });
            }, 5000);

            this.changeFilter('contacts');

            // Hide book pins not in viewport

            if (this.layers[0]) {

              this.hideMarkersNotInView(this.bookPinMarkers[0]);

              this.markerCluster.repaint();

            }

            if (!this.MapInitComplete && this.ResolveOnMapInit) {
              this.MapInitComplete = true;
              this.ResolveOnMapInit();
            }

          });

        }

        this.bookItems = groupedEntries;

        for (const row of Object.values(groupedEntries)) {

          let item;

          if (row['length'] > 1) {

            item = this.utils.find(row, 'message', 1);

            if (!item) {
              item = this.utils.find(row, 'type', 'Magabook');
            }

            if (!item) {
              item = this.utils.find(row, 'type', 'Small Paperback');
            }

            if (!item) {
              item = this.utils.find(row, 'type', 'DVD');
            }

            if (!item) {
              item = this.utils.find(row, 'type', 'Dropdown');
            }

            if (!item) {
              item = row[0];
            }


          } else {

            item = row[0];

          }

          if (item['latitude'] && parseFloat(item['latitude']) && parseFloat(item['longitude'])) {

            const bkNames = [];

            for (const itm of (row as any)) {
              bkNames.push(itm['bkName'] + (itm['qty'] > 1 ? '<small>(' + itm['qty'] + ')</small>' : ''));
            }

            const contentString = '<div id="content" style="color:#000;">' +
              '<h3 id="firstHeading" class="firstHeading">' + bkNames.join(', ') + '</h3>' +
              '<div id="bodyContent">' +
              '<p>' + item['person'] + ' @ ' + this.datePipe.transform(item['time'], 'medium') + '</p>' +
              '<p>' + item['latitude'] + ', ' + item['longitude'] + '</p>' +
              '</div>' +
              '</div>';

            const markerParams = {
              position: { lat: parseFloat(item['latitude']), lng: parseFloat(item['longitude']) },
              map: this.map,
              icon: null,
              optimized: false
            };

            const BookSvgKey = 'bookpin_' + item.code;
            let BookSvgUrl = '';

            if ((this.svgBookPins || {})[item.code]) {

              if (!this.svgMapPins[BookSvgKey]) {

                const SvgBookPin = this.svgBookPins[item.code];
                let svgCode = this.markersTpl.svg.bookpin;
                for (const [key, value] of Object.entries(SvgBookPin) as any) {
                  svgCode = svgCode.replace('{' + key + '}', value);
                }

                this.markersTpl.svg[BookSvgKey] = svgCode;

              }

              BookSvgUrl = this.getSvgDataUrl(BookSvgKey);

            } else {

              BookSvgUrl = this.getSvgDataUrl('genericbook', 'lightAqua');

            }

            markerParams.icon = {

              url: BookSvgUrl,
              scaledSize: new google.maps.Size(33.5, 60)

            };

            const marker = new google.maps.Marker(markerParams);

            if (!this.infoWindow) {
              this.infoWindow = new google.maps.InfoWindow({
                content: ''
              });
            }

            marker.addListener('click', () => {
              this.infoWindow.setContent(contentString);
              this.infoWindow.open(this.map, marker);
            });

            this.bookPinMarkers[0].push(marker);
            this.bookPinMarkers[1].push(row);

          }

        };

        this.refreshDisabled = 0;

        this.hideMarkersNotInView(this.bookPinMarkers[0]);

        if (this.markerCluster) {

          this.markerCluster.clearMarkers();
          this.markerCluster.addMarkers(this.bookPinMarkers[0]);

        } else {

          this.markerCluster = new MarkerClusterer(this.map, this.bookPinMarkers[0], {
            maxZoom: 14,
            ignoreHidden: true,
            minimumClusterSize: 1,
            styles: [
              {
                textColor: '#000',
                anchorText: [3, 0],
                url: this.getSvgDataUrl('bookarea', 'blue'),
                height: 50,
                width: 40
              },
              {
                textColor: '#000',
                anchorText: [3, 0],
                url: this.getSvgDataUrl('bookarea', 'gold'),
                height: 50,
                width: 40
              },
              {
                textColor: '#000',
                anchorText: [3, 0],
                url: this.getSvgDataUrl('bookarea', 'red'),
                height: 50,
                width: 40
              }
            ],
          });

        }

        if (!this.layers[0]) {
          this.markerCluster.clearMarkers();
        }

        // Location Points

        const pins = data['peoplePins'];

        const pointsGrouped = data['locationPoints'];

        // getEntries

        const location = [];

        for (const [personID, points] of Object.entries(pointsGrouped) as any) {

          // points row = [personID, lattitude, longitude, time, speed, battery, null]

          const myLocationGroups: Object = {
            personID: personID,
            tracks: []
          };

          let count = 0;
          let grouping = 1;

          const currentLocation = points[0]; // most recent logged location
          // const curCoords

          if (((new Date()).getTime() / 1000) - currentLocation.time < (60 * 60 * 3)) { // only show live if seen within the last 3 hours

            this.addLeMarker(
              { lat: currentLocation.lat, lng: currentLocation.long },
              personID,
              pins[personID],
              currentLocation
            );

          }

          const myPointsBySource = {
            traccar: [],
            contact: [],
            other: []
          };


          for (const point of points) {
            let source;
            if (['traccar', 'contact'].includes(point.source)) {
              source = point.source;
            } else {
              source = 'other';
            }
            myPointsBySource[source].push(point);
          };

          for (const [source, pointsRows] of Object.entries(myPointsBySource)) {

            for (const point of pointsRows || []) {

              // If this isn't the first row
              // And if the time has significantly changed
              // Or if the speed is greater than or equal to 20km per hour
              // Break into different group

              let lastPoint;

              if (myLocationGroups['tracks'][count]) {
                const lastGroup = myLocationGroups['tracks'][count];
                lastPoint = lastGroup[lastGroup.length - 1];
              }

              if (source === 'contact') {

                let color = point.GooglePlaceID ? 'red' : 'brightPink';

                let contacts, unsortedObj;

                contacts = this.utils.filter(data['contacts'], 'kf_locationID', point['kp_id']);

                if (contacts.length) {

                  let type = this.getContactType(contacts);

                  const followupDue = this.hasAnyFollowupDue(contacts);

                  if (point.GooglePlaceID) {

                    if (followupDue === 'overdue') {
                      color = 'overdue';
                    } else if (followupDue === 'close') {
                      color = 'theme';
                    } else {

                      if (type === 'contact') {

                        let hasPerson = contacts.find((row) => {
                            return row.name;
                          }) ? true : false;

                        color = hasPerson ? 'green' : 'grey';

                      } else {

                        color = 'grey';

                      }
                    }
                  }

                  if (!point.GooglePlaceID) {
                    type = 'unsure';
                  }

                  const svg = this.getSvgDataUrl(type, color);

                  const icon = {

                    url: svg,
                    scaledSize: new google.maps.Size(33.5, 60)

                  };

                  const markerOptions = {
                    position: { lat: point.lat, lng: point.long },
                    map: this.map,
                    clickable: this.permissions === 'Full',
                    icon: icon,
                    optimized: false
                  };

                  const marker = new google.maps.Marker(markerOptions);

                  if (!this.layers[4]) {

                    marker.setMap(null);

                  }

                  this.contactPinMarkers.push(marker);

                  if (!point.GooglePlaceID) {

                    unsortedObj = {
                      point: point,
                      marker: marker,
                      contacts: contacts
                    };

                    this.unsortedContacts.push(unsortedObj);

                  }

                  if (this.permissions === 'Full') {

                    marker.addListener('click', () => {

                      if (!point.GooglePlaceID) {

                        this.openUnsortedContact(unsortedObj);

                      } else {

                        const dialogData = {
                          address: null,
                          point: point,
                          questions: this.surveyQuestions,
                          title: 'Loading...',
                          id: null
                        };

                        const dialogRef = this.dialog.open(ViewContactsComponent, {
                          width: '900px',
                          disableClose: true,
                          position: {
                            top: '3vh'
                          },
                          data: dialogData
                        });

                        dialogData.id = dialogRef.id;

                      }

                    });

                  }

                  point.contacts = contacts;

                  this.contactPoints.push(point);

                }

              } else {

                if (point.accuracy < 60) {

                  if (
                    lastPoint &&
                    ((
                      source === 'traccar' &&
                      (
                        lastPoint.time - point.time > (30 * 60) || // 30 minutes, [3] == time
                        point.spd >= 10 ||  // || 10 knots == about 20km/hr [4] == speed ||
                        this.getDistanceBetweenPoints(lastPoint, point) > 50 // If greater than 75 meters from last point
                      )
                    ) || (
                        source === 'other' &&
                        this.getDistanceBetweenPoints(lastPoint, point) > 50 // If greater than 50 meters from last point
                      ))
                  ) {

                    if (grouping) {
                      count = myLocationGroups['tracks'].length;
                      grouping = 0;
                    }

                  } else {

                    grouping = 1;

                    myLocationGroups['tracks'][count] = myLocationGroups['tracks'][count] || [];

                    myLocationGroups['tracks'][count].push(point);

                  }
                }

              }

            }

          }

          myLocationGroups['tracks'] = myLocationGroups['tracks'].filter((group) => {
            const source = group[0].source === 'traccar' ? 'traccar' : 'other';
            return source !== 'traccar' || group.length < 4;
          });

          location.push(myLocationGroups);

        };

        for (const obj of location) {

          const id = obj['personID'];

          let pin;
          let color;
          let name;

          if (pins && pins[id]) {

            pin = pins[id]['url'];
            color = this.colors[pins[id]['color']];
            name = pins[id]['name'];

          } else {

            const le = this.utils.find(data.canvassers, 'kf_personID', id);

            if (le) {
              name = le.name;
            } else {
              name = 'Unkown Le';
            }
            color = '#' + this.utils.colorFromString(name);

          }

          obj['trackPaths'] = [];

          const newestPathTime = 0;

          for (const group of obj['tracks']) {
            
            const coords = group.map((row) => {
              return { lat: row.lat, lng: row.long };
            });

            const source = group[0].source;

            let path;

            if (source === 'traccar') {

              const lineSymbol = {
                path: google.maps.SymbolPath.CIRCLE,
                fillOpacity: 0.75,
                scale: 3
              };

              path = new google.maps.Polyline({
                path: coords,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 0,
                icons: [{
                  icon: lineSymbol,
                  offset: '0',
                  repeat: '10px'
                }],
                strokeWeight: 8
              });

              this.paths.walking.push(path);

              if (this.layers[2]) {
                path.setMap(this.map);
              }

            } else {

              path = new google.maps.Polyline({
                path: coords,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 0.75,
                strokeWeight: 8
              });

              this.paths.visits.push(path);

              if (this.layers[3]) {
                path.setMap(this.map);
              }

            }

            obj['trackPaths'].push(path);

            if (group[0].time > newestPathTime) {
              this.currentPaths[id] = {
                path: path,
                time: newestPathTime,
                lastSpeed: group[0].spd
              };
            }

          };

          if (
            this.currentPaths[id] &&
            (((new Date()).getTime() / 1000) - this.currentPaths[id].time > 60 * 5.5) // if older than 5m30s
          ) {
            delete (this.currentPaths[id]);
          }

        }

        this.myLocationPaths = location;

        this.setPolylineHandlers();

        this.addContactsMarkerCluster();

        this.changeFilter('contacts');

      });

    });

    return promise;

  }

  reload() {
    this.initialised = 0;
    this.db.update().then(() => {
      this.initMap();
    });
  }

  changeProgram() {

  }

  ngOnInit() {

    localStorage.path = '/map';

    this.db.getLeDetails().then(() => {

      this.subs.push(this.db.data.subscribe(() => {

        if (this.contactPinMarkers && this.contactPinMarkers.length) {

          for (const marker of this.contactPinMarkers) {

            marker.setMap(null);

          };

          this.contactPoints.length = 0;
          this.contactPinMarkers.length = 0;

        }

        if (!this.db.loaded) {
          this.db.update();
        }

        this.db.loaded.then(() => {
          this.initMap();
        });

      }));

      this.programs = this.db.programs;
      this.programID = this.db.program.kp_programID;

      this.db.q('magabooksApp:getWsPwd').then((data) => {

        const pwd = data['pwd'];

        this.wsConnection = new WebSocket('wss://magabooks:' + pwd + '@magabooks.org.au/ws/');

        this.wsConnection.onmessage = (e) => {

          const WsData = JSON.parse(e.data);

          if (WsData && WsData.location) {

            const coords = { lat: WsData['location'].lat, lng: WsData['location'].long };

            this.updateLeMarker(coords, WsData['personID'], WsData['pin'], WsData['location']);

            this.drawPath(coords, WsData['personID'], WsData['pin'], WsData['location'])

          }

        };

      });

    });

  }

}
